export default function PartnerSection() {
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f78cd58b4b9a3f99feab218dc0906ff4.jpg"
          alt="VIP партнёрская программа YAXIN"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0F1A]/95 via-[#0A0F1A]/80 to-[#0A0F1A]/60"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-[#C9A84C]"></div>
            <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">Партнёрская экосистема</span>
          </div>
          <h2 className="text-white mb-6" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(32px, 4.5vw, 60px)", letterSpacing: "0.03em" }}>
            СТРАТЕГИЧЕСКИЕ СОЮЗНИКИ<br />
            <span className="text-[#C9A84C]">ЭКОСИСТЕМА YAXIN</span>
          </h2>

          <div className="flex flex-col gap-6 mb-10">
            <div className="flex gap-4">
              <div className="w-10 h-10 flex items-center justify-center border border-[#C9A84C]/40 rounded-sm flex-shrink-0">
                <i className="ri-map-pin-2-line text-[#C9A84C] text-lg"></i>
              </div>
              <div>
                <h3 className="text-white font-bold text-base mb-1" style={{ fontFamily: "'Oswald', sans-serif" }}>Статус «Регионального Мастера»</h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  Мы выбираем одного сильного партнёра в регионе и передаём ему все рычаги управления спросом. Запросы от частных клиентов из вашего региона перенаправляются вам.
                </p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="w-10 h-10 flex items-center justify-center border border-[#C9A84C]/40 rounded-sm flex-shrink-0">
                <i className="ri-plane-line text-[#C9A84C] text-lg"></i>
              </div>
              <div>
                <h3 className="text-white font-bold text-base mb-1" style={{ fontFamily: "'Oswald', sans-serif" }}>Ежегодный VIP-саммит в Санья (Хайнань)</h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  В декабре мы приглашаем наших лучших партнёров на закрытое мероприятие в «Восточные Гавайи» за наш счёт — включая семью.
                </p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="w-10 h-10 flex items-center justify-center border border-[#C9A84C]/40 rounded-sm flex-shrink-0">
                <i className="ri-global-line text-[#C9A84C] text-lg"></i>
              </div>
              <div>
                <h3 className="text-white font-bold text-base mb-1" style={{ fontFamily: "'Oswald', sans-serif" }}>Больше, чем автозапчасти</h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  YAXIN — это ваш портал в промышленную мощь Китая. Мы открываем нашим VIP-партнёрам доступ к эксклюзивным ресурсам заводов за пределами автоиндустрии.
                </p>
              </div>
            </div>
          </div>

          <a
            href="#contact"
            className="inline-flex items-center gap-3 bg-[#C9A84C] hover:bg-[#b8943d] text-[#0A0F1A] font-bold text-base px-8 py-4 rounded-sm tracking-wide uppercase transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-list-3-line text-lg"></i>
            Запросить B2B прайс-лист
          </a>
        </div>
      </div>
    </section>
  );
}
